import { useCallback } from 'react';

import { SHARED_PREVIEW_CACHE_KEY } from '../../api/consts';
import { useGetPreviewMutation } from '../../api/endpoints/preview-endpoint';
import { AnnotationType, IApiAnswerResponse } from '../../api/types';
import { useAnalytics } from '../../redux/hooks/analytics';
import { useAppDispatch } from '../../redux/hooks/app-hooks';
import { useProject, useSources } from '../../redux/hooks/settings-hooks';
import { sendMetrics } from '../../redux/thunks/metrics-thunk';
import { previewAnswer } from '../../redux/thunks/preview-thunk';
import { MixpanelEvent } from '../../services/mixpanel/types';
import { getAnswerQuery } from '../../utils/answer';

export const useAnswerPreview = () => {
    const dispatch = useAppDispatch();
    const { sources } = useSources();
    const { project } = useProject();
    const [log] = useAnalytics();
    const [getPreview] = useGetPreviewMutation({
        fixedCacheKey: SHARED_PREVIEW_CACHE_KEY,
    });

    return useCallback(
        (answer: IApiAnswerResponse, shortcutUsed: boolean = false) => {
            if (!answer) {
                return;
            }

            getPreview({
                project,
                doc_id: answer.doc_id,
                query: getAnswerQuery(answer),
                source_id: answer.source_id,
                source_type: answer.source_type,
                preview_type: answer.preview_type,
            });
            dispatch(previewAnswer(answer));
            dispatch(
                sendMetrics({
                    event: MixpanelEvent.OPEN_SMART_PREVIEW,
                    meta: {
                        use_shortcut: shortcutUsed,
                        doc_id: answer.doc_id,
                    },
                    injectAnswersMetrics: {
                        sources,
                    },
                })
            );
            log({ answer, type: AnnotationType.PREVIEW_CLICK });
        },
        [dispatch, getPreview, log, project, sources]
    );
};
